import { PROJECT_APP_SETTINGS_PAGE, PROJECT_APP_SETTINGS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const projectSettingsRoute = createGlobalRoute({
	exact: true,
	name: PROJECT_APP_SETTINGS_PAGE,
	path: PROJECT_APP_SETTINGS_PATH,
	capabilities: ['projects_app:administer'],
	subproduct: 'townsquare-projects',
	enableRestrictedFallback: true,
});
